import { resources } from "@constants/hardcoded-strings";
import { AXNUIFormContentSlotContentTypes } from "@iddataweb/idw-common-ui/enums";
import { AXNUIContentPostFormHelpText, AXNUILayoutHelpTextInner } from "@iddataweb/idw-common-ui/types";
import { TabTitleWithErrorCount } from "@containers/common/tab-title-with-error-count/tab-title-with-error-count";
import { ErrorAlert } from "@containers/common/error-alert/error-alert";
import { ThemingGenericContentSlotValidationErrors } from "@idw-types/common/validation/common/theming-validation-errors";
import { PreviewEntityTypes } from "@enums/preview-entity-types";

export const getThemingGenericContentSlotValidationErrors = (
    previewEntityType: PreviewEntityTypes,
    isUsingThemedUI: boolean,
    tabName: string,
    axnuiContentPostFormHelpText: AXNUIContentPostFormHelpText,
    axnuiLayoutHelpText: AXNUILayoutHelpTextInner
): ThemingGenericContentSlotValidationErrors => {
    let count = 0;
    let customHtmlError = null;
    let customCssError = null;
    let imageUrlError = null;
    let imageWidthError = null;
    let imageHeightError = null;
    let modalLinkTextError = null;
    let modalHtmlTextError = null;
    let predefinedHelpTextTypeError = null;
    let explicitConsentError = null;

    if (isUsingThemedUI && (axnuiLayoutHelpText?.order || []).length > 0 && previewEntityType === PreviewEntityTypes.VERIFICATION_SERVICE) {
        axnuiLayoutHelpText.order.forEach(helpTextType => {
            if (helpTextType === AXNUIFormContentSlotContentTypes.USE_HTML_CSS) {
                if (!axnuiLayoutHelpText.htmlText) {
                    count += 1;
                    customHtmlError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
                }
                if (!axnuiLayoutHelpText.cssContent) {
                    count += 1;
                    customCssError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
                }
            } else if (helpTextType === AXNUIFormContentSlotContentTypes.USE_IMAGE) {
                if (!axnuiLayoutHelpText.imageUrl) {
                    count += 1;
                    imageUrlError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
                }

                if (axnuiLayoutHelpText.imageWidth !== "auto") {
                    if (!axnuiLayoutHelpText.imageWidth) {
                        count += 1;
                        imageWidthError = <ErrorAlert><span>This field is required. Please enter a valid image width followed by &quot;px&quot; or use the CSS value &quot;auto&quot;</span></ErrorAlert>;
                    } else if (`${axnuiLayoutHelpText.imageWidth}`.includes("-")) {
                        count += 1;
                        imageWidthError = <ErrorAlert><span>The Image Width cannot be negative</span></ErrorAlert>;
                    } else if (!`${axnuiLayoutHelpText.imageWidth}`.includes("px") || `${axnuiLayoutHelpText.imageWidth}`.includes(" ")) {
                        count += 1;
                        imageWidthError = <ErrorAlert><span>Please use the format &quot;5px&quot; with no spaces or use the CSS value &quot;auto&quot;</span></ErrorAlert>;
                    } else {
                        const numberValue = `${axnuiLayoutHelpText.imageWidth}`.split("px")[0];
                        if (isNaN(parseInt(numberValue))) {
                            count += 1;
                            imageWidthError = <ErrorAlert><span>Please use the format &quot;5px&quot; with no spaces or use the CSS value &quot;auto&quot;</span></ErrorAlert>
                        }
                    }
                }
    
                if (axnuiLayoutHelpText.imageHeight !== "auto") {
                    if (!axnuiLayoutHelpText.imageHeight) {
                        count += 1;
                        imageHeightError = <ErrorAlert><span>This field is required. Please enter a valid image height followed by &quot;px&quot; or use the CSS value &quot;auto&quot;</span></ErrorAlert>;
                    } else if (`${axnuiLayoutHelpText.imageHeight}`.includes("-")) {
                        count += 1;
                        imageHeightError = <ErrorAlert><span>The Image Height cannot be negative</span></ErrorAlert>;
                    } else if (!`${axnuiLayoutHelpText.imageHeight}`.includes("px") || `${axnuiLayoutHelpText.imageHeight}`.includes(" ")) {
                        count += 1;
                        imageHeightError = <ErrorAlert><span>Please use the format &quot;5px&quot; with no spaces or use the CSS value &quot;auto&quot;</span></ErrorAlert>;
                    } else {
                        const numberValue = `${axnuiLayoutHelpText.imageHeight}`.split("px")[0];
                        if (isNaN(parseInt(numberValue))) {
                            count += 1;
                            imageHeightError = <ErrorAlert><span>Please use the format &quot;5px&quot; with no spaces or use the CSS value &quot;auto&quot;</span></ErrorAlert>
                        }
                    }
                }
            } else if (helpTextType === AXNUIFormContentSlotContentTypes.USE_MODAL) {
                if (!axnuiLayoutHelpText.linkText) {
                    count += 1;
                    modalLinkTextError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
                }
                if (!axnuiLayoutHelpText.modalHtmlText) {
                    count += 1;
                    modalHtmlTextError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
                }
            } else if (helpTextType === AXNUIFormContentSlotContentTypes.USE_PREDEFINED_FORM_HELP_TEXT) {
                if (!axnuiLayoutHelpText.formHelpTextType) {
                    count += 1;
                    predefinedHelpTextTypeError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
                }
            } else if (helpTextType === AXNUIFormContentSlotContentTypes.USE_EXPLICIT_CONSENT_INPUT) {
                if (!axnuiContentPostFormHelpText.explicitConsent) {
                    count += 1;
                    explicitConsentError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>
                }
            }
        });
    }

    return {
        customHtmlError,
        customCssError,
        imageUrlError,
        imageWidthError,
        imageHeightError,
        modalLinkTextError,
        modalHtmlTextError,
        predefinedHelpTextTypeError,
        explicitConsentError,
        count: count,
        tabTitle: <TabTitleWithErrorCount
            tabName={tabName}
            errorCount={count}
        />
    };
};